import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import "../styles/ProductDetails.css";

const ProductDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/products/${id}`
        );
        setProduct(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching product:", error);
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) {
    return <p className="loading-message">Loading product details...</p>;
  }

  if (!product) {
    return <p className="error-message">Product not found.</p>;
  }

  return (
    <div className="product-details-container">
      <Helmet>
        <title>{product.name} - Relisonpharma</title>
        <meta name="description" content={product.description} />
        <meta property="og:title" content={product.name} />
        <meta property="og:description" content={product.description} />
        <meta property="og:image" content={product.image} />
        <meta property="og:type" content="product" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="breadcrumb">
        <a href="/">Home</a> &gt; <a href="/products">Products</a> &gt;{" "}
        <span>{product.name}</span>
      </div>

      <div className="product-details-grid">
        <div className="product-image-wrapper">
              <img
  src={
    product.image.startsWith("http")
      ? product.image
      : `https://res.cloudinary.com/ddv0dhxf6/image/upload/relison-products/${product.image.split("\\").pop()}`
  }
  alt={product.name}
            className="product-image"
          />
        </div>
        <div className="product-info">
          <h1 className="product-title">{product.name}</h1>
          <p className="product-subtitle">{product.description}</p>
          <p className="product-quantity">
            Quantity: <strong>{product.quantity}</strong>
          </p>
          <div className="product-description-tab">
            <h3>Description</h3>
            <p>{product.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
